import type { CalendarSurfaceStore } from '../../index';
import { action } from 'satcheljs/lib/legacy';

/**
 * Called to lock the currently selected item on surface.
 * @store The surface store
 */
export let lockSelectedItem = action('lockSelectedItems')(function lockSelectedItems(
    store: CalendarSurfaceStore
) {
    store.lockSelectedItem = true;
});
